const DEPENDENCY_GRADE = {
  NO_GRADE: "No tiene grado",
  GRADE_1: "Grado 1",
  GRADE_2: "Grado 2",
  GRADE_3: "Grado 3",
} as const;

const dependencyGrades = [
  {
    value: DEPENDENCY_GRADE.NO_GRADE,
  },
  {
    value: DEPENDENCY_GRADE.GRADE_1,
  },
  {
    value: DEPENDENCY_GRADE.GRADE_2,
  },
  {
    value: DEPENDENCY_GRADE.GRADE_3,
  },
];

export function dependencyGradesList() {
  return dependencyGrades;
}
